import React from 'react';

import style from './on-off-switch.module.scss';

const OnOffSwitch = ({ on }) => {
  return (
    <span
      className={`${style.onOffSwitch} ${
        on ? ` ${style.on}` : ` ${style.off}`
      }`}
    />
  );
};

export { OnOffSwitch };
